var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.07,
    height: 19.573,
    viewBox: "0 0 20.07 19.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-github",
    "data-name": "Icon simple-github",
    d: "M10.035.445A10.036,10.036,0,0,0,6.862,20c.5.094.686-.216.686-.483,0-.238-.008-.87-.013-1.706-2.791.605-3.38-1.346-3.38-1.346A2.66,2.66,0,0,0,3.038,15c-.909-.622.07-.61.07-.61a2.1,2.1,0,0,1,1.537,1.034,2.138,2.138,0,0,0,2.923.835A2.139,2.139,0,0,1,8.2,14.915C5.975,14.664,3.633,13.8,3.633,9.956A3.871,3.871,0,0,1,4.666,7.264a3.568,3.568,0,0,1,.088-2.656s.84-.269,2.76,1.029a9.461,9.461,0,0,1,5.018,0c1.907-1.3,2.747-1.029,2.747-1.029a3.667,3.667,0,0,1,.1,2.656,3.887,3.887,0,0,1,1.029,2.693c0,3.855-2.346,4.7-4.579,4.951a2.4,2.4,0,0,1,.677,1.857c0,1.343-.013,2.422-.013,2.748,0,.263.176.577.69.477A10.023,10.023,0,0,0,10.035.445",
    transform: "translate(0 -0.445)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleGithub);
export default __webpack_public_path__ + "static/media/simple-github.92fc0b4a7009955d9dd087528621557d.svg";
export { ForwardRef as ReactComponent };